import React from 'react';
import { HeaderGroup } from 'react-table';

interface AdvancedTableHeaderProps {
  table: any;
  showFilters?: boolean;
}

const AdvancedTableHeader: React.FC<AdvancedTableHeaderProps> = ({
  table,
  showFilters,
}) => {
  const { headerGroups, setFilters } = table;

  return (
    <thead className="bg-gray-100 dark:bg-gray-800">
      {headerGroups.map((headerGroup: HeaderGroup) => {
        const {
          key: headerGroupKey,
          ...restHeaderGroupProps
        } = headerGroup.getHeaderGroupProps();

        return (
          <React.Fragment key={headerGroupKey}>
            {/* ======================== HEADER ROW ======================== */}
            <tr {...restHeaderGroupProps}>
              {headerGroup.headers.map((column) => {
                const {
                  key: colKey,
                  ...restColProps
                } = column.getHeaderProps(
                  column.getSortByToggleProps()
                );

                return (
                  <th
                    key={colKey}
                    {...restColProps}
                    className="
                      px-5
                      py-4
                      text-left
                      text-sm
                      font-semibold
                      text-gray-800
                      whitespace-nowrap
                      dark:text-gray-200
                      sm:text-base
                    "
                  >
                    <div className="flex min-w-max items-center">
                      {column.render('Header')}

                      <div className="ml-2 inline-flex flex-col space-y-[2px]">
                        {/* sort up */}
                        <span className="inline-block">
                          <svg
                            className="fill-current"
                            width="10"
                            height="5"
                            viewBox="0 0 10 5"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M5 0L0 5H10L5 0Z" />
                          </svg>
                        </span>

                        {/* sort down */}
                        <span className="inline-block">
                          <svg
                            className="fill-current"
                            width="10"
                            height="5"
                            viewBox="0 0 10 5"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M5 5L10 0L0 0L5 5Z" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </th>
                );
              })}
            </tr>

            {/* ======================== FILTER ROW ======================== */}
            {showFilters && (
              <tr>
                {headerGroup.headers.map((column: any) => (
                  <th
                    key={column.id}
                    className="px-4 py-2"
                  >
                    <input
                      type="text"
                      placeholder="Buscar..."
                      className="
                        w-full
                        min-w-[160px]
                        rounded-lg
                        border-[1.5px]
                        border-stroke
                        bg-transparent
                        px-5
                        py-3
                        text-black
                        outline-none
                        transition
                        focus:border-primary
                        active:border-primary
                        disabled:cursor-default
                        disabled:bg-whiter
                        dark:border-form-strokedark
                        dark:bg-form-input
                        dark:text-white
                        dark:focus:border-primary
                      "
                      onChange={(e) =>
                        setFilters((prev: any) => ({
                          ...prev,
                          [column.id]: e.target.value,
                        }))
                      }
                    />
                  </th>
                ))}
              </tr>
            )}
          </React.Fragment>
        );
      })}
    </thead>
  );
};

export default AdvancedTableHeader;